import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLinkWithHref, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { RequirePermissionsDirective } from '../../directives/require-permissions/require-permissions.directive';
import { IconComponent } from '../icon/icon.component';
import { ProfileComponent } from '../profile/profile.component';
import { AboutComponent } from '../about/about.component';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import { navigationRoutes, type NavigationRoute } from './navigation.service';
import { BetaToolComponent } from '../beta-tool/beta-tool.component';
import { environment } from '@/environments/environment';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'dpqa-navigation',
  imports: [
    RouterLinkWithHref,
    RouterLinkActive,
    IconComponent,
    TranslatePipe,
    ProfileComponent,
    RequirePermissionsDirective,
    AboutComponent,
    NzDividerComponent,
    BetaToolComponent,
  ],
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.less'],
})
export class NavigationComponent {
  protected routes: NavigationRoute[] = navigationRoutes;
  public isBetaEnvironment = environment.isBetaEnvironment;
}
